/** El número para la prueba del asistente y «Enviar prueba». */
import { useId } from "react";
import { Loader2, Smartphone } from "lucide-react";

export function FormPrueba({ numero, onNumero, enviando, onEnviar }: { numero: string; onNumero: (v: string) => void; enviando: boolean; onEnviar: () => void }) {
  const idNum = useId();
  return (
    <div className="flex items-end gap-2 flex-wrap">
      <div>
        <label htmlFor={idNum} className="text-xs font-semibold text-slate-600">Tu número</label>
        <input id={idNum} type="tel" value={numero} onChange={(e) => onNumero(e.target.value)} placeholder="+54 9 11 5544-3322" autoComplete="tel"
          className="mt-1.5 w-64 max-w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-violet-500" />
      </div>
      <button type="button" onClick={onEnviar} disabled={enviando || !numero.trim()}
        className="h-11 px-4 rounded-xl border border-violet-200 bg-violet-50 text-violet-700 text-sm font-semibold hover:bg-violet-100 disabled:opacity-50 inline-flex items-center gap-2">
        {enviando ? <Loader2 size={14} className="animate-spin" /> : <Smartphone size={14} />} Enviar prueba
      </button>
    </div>
  );
}
